import { get } from 'svelte/stores'
import { currentSheet } from './root.js'
import Api from '../services/Api'

export const exportSheet = async (sheetId) => {
  const result = await Api.get(`/sheets/export/${sheetId}`)
  if (result.status === 200) {
    currentSheet.update((sheet) => ({ ...sheet, exported: true }))
  }
}
